import { shortDate } from '../utils/formatters';
import getBrowser from '../utils/getBrowser';

export const formatDateReport = date => {
    if (!date) return null;
    const browser = getBrowser();
    const isSafari = browser == 'Safari';
    const dt = isSafari ? date.replace(/\s/, 'T') : date;
    return shortDate(dt);
};
